// Version : 0.0.2
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Removed Trenary Operator, moved it to main page.
// Modified Date: 20-08-2025
import { takeLatest, put, all, call } from 'redux-saga/effects';

import AssignUserRightsTypes from './assign-users-rights.types';
import {
	createAssignUserRightsForPage,
	updateAssignUserRightsForPage,
	saveAssignUserRightsForAllPage,
	fetchListUserControlDetails,
} from './assign-users-rights.service';

import {
	createUserControlRightsPageSuccess,
	createUserControlRightsPageFailure,
	createUserControlRightsPageResponseChanged,
	updateUserControlRightsPageSuccess,
	updateUserControlRightsPageFailure,
	updateUserControlRightsPageResponseChanged,
	saveUserControlRightsForAllPageSuccess,
	saveUserControlRightsForAllPageFailure,
	saveUserControlRightsForAllPageResponseChanged,
	fetchUserControlDetailsListSuccess,
	fetchUserControlDetailsListFailure,
	fetchUserControlDetailsListResponseChanged,
} from './assign-users-rights.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START ADD USER ASSIGN CONTROL RIGHTS PAGE DETAILS  ******************** */
export function* createUserControlRightsPageDetails({ payload }: any) {
	try {
		const {
			companyID,
			isShowhide,
			isAdd,
			isEdit,
			isDelete,
			subMenuId,
			menuId,
			isApprove,
			userRole,
			mainMenuID,
			customName,
			createdBy,
			logNotes,
			mapMenuId,
			databaseName,
			userAccessBranchID,
		} = payload;
		const key = 'CreateAsignControMenuKey';
		const jsonData = {
			CompanyID: companyID,
			IsShowhide: isShowhide,
			IsAdd: isAdd,
			IsEdit: isEdit,
			IsDelete: isDelete,
			SubMenuId: subMenuId,
			MenuId: menuId,
			IsApprove: isApprove,
			UserRole: userRole,
			MainMenuID: mainMenuID,
			CustomName: customName,
			CreatedBy: createdBy,
			LogNotes: logNotes,
			MapMenuId: mapMenuId,
			DatabaseName: databaseName,
			UserAccessBranchID: userAccessBranchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(createAssignUserRightsForPage, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createUserControlRightsPageFailure(responseData.data));
		} else {
			yield put(createUserControlRightsPageSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createUserControlRightsPageFailure(error));
	}
}

export function* resetCreateAssignUserControlRightsPageResponse() {
	yield put(createUserControlRightsPageResponseChanged());
}

export function* onCreateAssignUserControlRightsPageDetails() {
	yield takeLatest(
		AssignUserRightsTypes.CREATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_START,
		createUserControlRightsPageDetails,
	);
}

export function* onCreateAssignUserControlRightsPageResponseReset() {
	yield takeLatest(
		AssignUserRightsTypes.CREATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_RESPONSE_RESET,
		resetCreateAssignUserControlRightsPageResponse,
	);
}
/** *********************  END ADD USER ASSIGN CONTROL RIGHTS PAGE DETAILS ******************** */

/** *********************  START UPDATE USER ASSIGN CONTROL RIGHTS PAGE DETAILS  ******************** */
export function* updateUserControlRightsPageDetails({ payload }: any) {
	try {
		const {
			companyID,
			isShowhide,
			isAdd,
			isEdit,
			isDelete,
			subMenuId,
			menuId,
			isApprove,
			userRole,
			mainMenuID,
			customName,
			createdBy,
			logNotes,
			mapMenuId,
			databaseName,
			userAccessBranchID,
		} = payload;
		const key = 'UpdateAssignControlUserMenuKey';
		const jsonData = {
			CompanyID: companyID,
			IsShowhide: isShowhide,
			IsAdd: isAdd,
			IsEdit: isEdit,
			IsDelete: isDelete,
			IsApprove: isApprove,
			SubMenuId: subMenuId,
			MenuId: menuId,
			UserRole: userRole,
			MainMenuID: mainMenuID,
			CustomName: customName,
			CreatedBy: createdBy,
			LogNotes: logNotes,
			MapMenuId: mapMenuId,
			DatabaseName: databaseName,
			UserAccessBranchID: userAccessBranchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateAssignUserRightsForPage, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateUserControlRightsPageFailure(responseData.data));
		} else {
			yield put(updateUserControlRightsPageSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateUserControlRightsPageFailure(error));
	}
}

export function* resetUpdateAssignUserControlRightsPageResponse() {
	yield put(updateUserControlRightsPageResponseChanged());
}

export function* onUpdateAssignUserControlRightsPageDetails() {
	yield takeLatest(
		AssignUserRightsTypes.UPDATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_START,
		updateUserControlRightsPageDetails,
	);
}

export function* onUpdateAssignUserControlRightsPageResponseReset() {
	yield takeLatest(
		AssignUserRightsTypes.UPDATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_RESPONSE_RESET,
		resetUpdateAssignUserControlRightsPageResponse,
	);
}
/** *********************  END UPDATE USER ASSIGN CONTROL RIGHTS PAGE DETAILS ******************** */

/** *********************  START SAVE USER ASSIGN CONTROL RIGHTS FOR ALL PAGE DETAILS  ******************** */
export function* saveUserControlRightsForAllPageDetails({ payload }: any) {
	try {
		const {
			companyID,
			userAccessDetails,
			userRoleID,
			createdBy,
			logNotes,
			databaseName,
			userAccessBranchID,
		} = payload;
		const key = 'SaveAssignControlUserAllMenuKey';
		const jsonData = {
			CompanyID: companyID,
			UserAccessDetails: userAccessDetails,
			UserRole: userRoleID,
			CreatedBy: createdBy,
			LogNotes: logNotes,
			DatabaseName: databaseName,
			UserAccessBranchID: userAccessBranchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(saveAssignUserRightsForAllPage, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(saveUserControlRightsForAllPageFailure(responseData.data));
		} else {
			yield put(saveUserControlRightsForAllPageSuccess(responseData.data));
		}
	} catch (error) {
		yield put(saveUserControlRightsForAllPageFailure(error));
	}
}

export function* resetSaveUserControlRightsForAllPageResponse() {
	yield put(saveUserControlRightsForAllPageResponseChanged());
}

export function* onSaveUserControlRightsForAllPageDetails() {
	yield takeLatest(
		AssignUserRightsTypes.SAVE_USER_ASSIGN_CONTROL_ALL_PAGE_START,
		saveUserControlRightsForAllPageDetails,
	);
}

export function* onSaveUserControlRightsForAllPageResponseReset() {
	yield takeLatest(
		AssignUserRightsTypes.SAVE_USER_ASSIGN_CONTROL_ALL_PAGE_RESPONSE_RESET,
		resetSaveUserControlRightsForAllPageResponse,
	);
}
/** *********************  END UPDATE USER ASSIGN CONTROL RIGHTS PAGE DETAILS ******************** */

/** *********************  START FETCH USER CONTROL DETAILS LIST  ******************** */
export function* fetchUserControlDetailsList({ payload }: any) {
	try {
		const { companyID, userRoleID, databaseName } = payload;
		const key = 'FetchUserControlDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			UserRoleID: userRoleID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchListUserControlDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchUserControlDetailsListFailure(responseData.data));
		} else {
			yield put(fetchUserControlDetailsListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchUserControlDetailsListFailure(error));
	}
}

export function* resetFetchListUserControlDetailsResponse() {
	yield put(fetchUserControlDetailsListResponseChanged());
}

export function* onFetchListUserControlDetails() {
	yield takeLatest(
		AssignUserRightsTypes.FETCH_LIST_USER_CONTROL_DETAILS_START,
		fetchUserControlDetailsList,
	);
}

export function* onFetchListUserControlDetailsResponseReset() {
	yield takeLatest(
		AssignUserRightsTypes.FETCH_LIST_USER_CONTROL_DETAILS_RESPONSE_RESET,
		resetFetchListUserControlDetailsResponse,
	);
}

/** *********************  END FETCH USER CONTROL DETAILS LIST ******************** */

export function* assignUserRightsMasterSaga() {
	yield all([
		call(onCreateAssignUserControlRightsPageDetails),
		call(onCreateAssignUserControlRightsPageResponseReset),
		call(onUpdateAssignUserControlRightsPageDetails),
		call(onUpdateAssignUserControlRightsPageResponseReset),
		call(onSaveUserControlRightsForAllPageDetails),
		call(onSaveUserControlRightsForAllPageResponseReset),
		call(onFetchListUserControlDetails),
		call(onFetchListUserControlDetailsResponseReset),
	]);
}
